
/**
 * NicePay 결제 설정 응답
 */
export interface NicePayConfigResponse {
  /** 액션 URL */
  actionUrl: string;
  /** 결제 금액 */
  amount: number;
  /** 빌링키 등록 완료 후 리다이렉트 URL */
  billingReturnUrl: string;
  /** NicePay 클라이언트 ID */
  clientId: string;
  /** 전문 생성일시 */
  ediDate: string;
  /** 상품명 */
  goodsName: string;
  /**
   * 가맹점 사용자 ID
   * @nullable
   */
  mallUserId?: string | null;
  /** 주문 ID */
  orderId: string;
  /** 결제 완료 후 리다이렉트 URL */
  returnUrl: string;
  /** 서명 데이터 */
  signData: string;
}
